module.exports = __webpack_public_path__ + "images/category_lp/retro_game/mainBg_dad2d25fcc174b8c2ea880ea938da9b0.png";